(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["crossfade-record-audio"] && !Shopify.designMode) return;
  try {
    document.addEventListener('play', (event) => {
    const player = event.target;
    if (!(player instanceof HTMLAudioElement) || !player.closest('[data-cf-record-audio]')) return;
    document.querySelectorAll('[data-cf-record-audio] audio').forEach((other) => {
      if (other !== player) other.pause();
    });
  }, true);
  document.addEventListener('error', (event) => {
    const player = event.target;
    if (!(player instanceof HTMLAudioElement) || !player.closest('[data-cf-record-audio]')) return;
    const message = player.nextElementSibling;
    if (message?.classList.contains('cf-record-audio__error')) message.hidden = false;
  }, true);
  document.addEventListener('canplay', (event) => {
    const player = event.target;
    if (!(player instanceof HTMLAudioElement) || !player.closest('[data-cf-record-audio]')) return;
    const message = player.nextElementSibling;
    if (message?.classList.contains('cf-record-audio__error')) message.hidden = true;
  }, true);
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) document.querySelectorAll('[data-cf-record-audio] audio').forEach((player) => player.pause());
  });
  } catch(e) { console.error(e); }
})();

})();
